import styled, { css } from 'styled-components';
import Text from '@components/text';
import Image from '@components/image';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: 3.5rem;
    align-items: center;
    width: 100%;

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      row-gap: 3.25rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      row-gap: 3rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      row-gap: 2.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      align-items: flex-start;
      row-gap: 2rem;
    }
  `}
`;

export const Divider = styled.div`
  ${({ theme }) => css`
    display: block;
    width: 5rem;
    height: 0.375rem;
    background-color: ${theme.colors.primary};
    border-radius: 0.125rem;
    margin-bottom: 1rem;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      margin-bottom: 0.5rem;
    }
  `}
`;

export const StyledImage = styled.img`
  width: 100%;
  height: auto;
`;

export const StyledHeading = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colors.black};
  `}
`;

export const StyledTextContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    width: 100%;
    max-width: 64rem;
    text-align: center;
    align-items: center;

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      gap: 1.125rem;
      max-width: 52rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      gap: 1rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      gap: 0.875rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      gap: 0.75rem;
      text-align: left;
      align-items: flex-start;
    }
  `}
`;

export const PaddingWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      padding: 0 2rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      padding: 0 1rem;
    }
  `}
`;

export const StyledGrid = styled.div`
  ${({ theme }) => css`
    display: grid;
    gap: 2rem;
    width: 100%;
    grid-template-columns: repeat(2, 1fr);

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      gap: 2rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      gap: 1.25rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      grid-template-columns: repeat(1, 1fr);
      gap: 1.125rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      grid-template-columns: repeat(1, 1fr);
      gap: 1rem;
    }
  `}
`;

export const StyledBlock = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.75rem;
    background-color: ${theme.colors.light}66;
    padding: 2.5rem 2rem 2rem 2rem;
    border-radius: calc(${theme.borderRadius.large} / 1.5);

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      padding-top: 2.25rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      padding: 1.5rem 1rem;
      padding-top: 2rem;
      gap: 1.5rem;
    }
  `}
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;

export const StyledIconImage = styled(Image)`
  width: 100%;
  height: 100%;
`;

export const StyledSocialIconImage = styled.div<{ imageUrl: string }>`
  ${({ theme, imageUrl }) => css`
    width: 1rem;
    height: 1rem;
    background-color: ${theme.colors.black};
    mask: url(${imageUrl}) no-repeat left center / contain;
    -webkit-mask: url(${imageUrl}) no-repeat left center / contain;
  `}
`;

export const StyledIcon = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 8rem;
    height: 3.5rem;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      height: 2.75rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      height: 2.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      height: 2rem;
    }
  `}
`;

export const StyledSocialLinks = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const StyledSocialLink = styled.a`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2.5rem;
    transition: opacity 0.2s ease;
    border-radius: 50%;
    background-color: ${theme.colors.primary};
    transition: transform 0.125s ease;

    &:hover {
      transform: scale(1.125);
      background-color: ${theme.colors.black};

      ${StyledSocialIconImage} {
        background-color: ${theme.colors.white};
      }
    }

    &:active {
      transform: scale(0.9375);
    }
  `}
`;
